function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M9.57797 6.40132C9.57797 5.07511 10.6685 4 12.0137 4C13.3589 4 14.4494 5.07511 14.4494 6.40132C14.4494 7.72753 13.3589 8.80264 12.0137 8.80264C10.6685 8.80264 9.57797 7.72753 9.57797 6.40132Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M10.39 8.80264H13.6387C13.8876 8.80317 14.1338 8.85218 14.3634 8.94688C14.5929 9.04157 14.8012 9.18007 14.9762 9.3544C14.9914 9.36947 15.0056 9.38541 15.0188 9.40214L17.6933 12.7913C17.905 13.0459 18.0138 13.3688 17.9986 13.6979C17.9832 14.0304 17.8423 14.3451 17.6037 14.5804C17.365 14.8157 17.0457 14.9546 16.7085 14.9698C16.3748 14.9848 16.0474 14.8776 15.7892 14.669L14.8122 13.9217L16.1505 18.0944C16.2209 18.2408 16.2638 18.3988 16.2768 18.5606C16.2912 18.7401 16.2686 18.9206 16.2104 19.0912C16.1522 19.2618 16.0595 19.4191 15.9381 19.5535C15.8166 19.6879 15.6687 19.7967 15.5035 19.8733C15.3382 19.9499 15.1589 19.9927 14.9764 19.9991C14.7939 20.0056 14.612 19.9756 14.4416 19.9109C14.2712 19.8462 14.1158 19.7482 13.9848 19.6227C13.8663 19.5091 13.7699 19.3752 13.7004 19.2276L12.0138 16.6086L10.3219 19.2357C10.2478 19.3808 10.1475 19.5114 10.0257 19.6211C9.89429 19.7395 9.74053 19.8312 9.57318 19.8911C9.40583 19.9509 9.22817 19.9776 9.05035 19.9697C8.87253 19.9618 8.69802 19.9195 8.53679 19.8451C8.37556 19.7707 8.23077 19.6658 8.11068 19.5363C7.9906 19.4067 7.89756 19.2551 7.8369 19.0901C7.77624 18.9252 7.74913 18.75 7.75712 18.5747C7.76452 18.4124 7.80185 18.253 7.86717 18.1041L9.21287 13.9236L8.24677 14.6626C7.99242 14.8831 7.66313 15.0018 7.32391 14.9945C6.97662 14.9871 6.64552 14.8483 6.39916 14.6069C6.15281 14.3654 6.01007 14.0398 6.00051 13.6975C5.99116 13.3624 6.11011 13.0364 6.33322 12.7841L9.00202 9.40214C9.01614 9.38425 9.0314 9.36727 9.04771 9.35129C9.40392 9.00233 9.88492 8.8053 10.3871 8.80265L10.39 8.80264Z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgAccess = function SvgAccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/access.6417523f.svg";
export { ForwardRef as ReactComponent };